import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set title immediately before React mounts
document.title = 'MegaPack Psicología: Carrera Resuelta — Sistema Completo para Estudiantes de Psicología en Argentina';
// Preconnect to critical origins BEFORE React renders
const origins = [{
  href: 'https://res.cloudinary.com',
  cross: true
}, {
  href: 'https://images.unsplash.com',
  cross: true
}];
origins.forEach(({
  href,
  cross
}) => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  if (cross) link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
  // dns-prefetch fallback
  const dns = document.createElement('link');
  dns.rel = 'dns-prefetch';
  dns.href = href;
  document.head.appendChild(dns);
});
// Preload hero image (LCP) — MUST match actual src in App.tsx
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.href = 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_760/v1777938271/heylloyd-image-1777865023115_1_-Photoroom_mrxxw9.webp';
preloadImg.setAttribute('fetchpriority', 'high');
document.head.appendChild(preloadImg);
render(<App data-id="element-386" />, document.getElementById('root'));